import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddPoll(props) {
  return(
    <PostAdd 
      targetVid={"poll_categories"}
      addPostEndpoint={apiEndpoints.polls}
      editRoute={"/polls/edit"}
      entityType={"poll"}
      pageTitle={"Create a poll post"}
      returnRoute={"/polls-creator"}
      categoryName={"polls"}
    />
  )
}
